$(function() {
  $('.sw-NavB_Body').matchHeight();
  $('.sw-NavB_Foot').matchHeight();
}());
